import styles from "./home.module.css";

const Panner = () => {
  return (
    <div className={styles.panner}>
      <h2>
        Focus On <span>Progress</span> Not Perfection.
      </h2>
    </div>
  );
};

export default Panner;
